import { LOCAL_STORAGE_KEYS } from '../../constants';
import { removeLocalStorageItem } from '../storage';

export const deleteCriticalMessageStorage = () => {
  removeLocalStorageItem(LOCAL_STORAGE_KEYS.READ_CRITICAL_MESSAGE);
};
